import React, { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

export default function Text ({ currentQuestion, data, setText, text, responses }) {
	const { t } = useTranslation('survey');

	const currentQ = document.querySelector('#q' + [currentQuestion + 1]);
	const errorSelector = 'q' + [currentQuestion + 1] + 'error';
	let maxChars = 99999;
	if (data[currentQuestion].max_characters) {
		maxChars = data[currentQuestion].max_characters;
	}
	const changeHandler = (e) => {
		setText(e.target.value);
		if (e.target.value.length > maxChars) {
			// Move the p into the error message
			document.querySelector('#' + errorSelector).append(document.querySelector('#' + errorSelector + '-content'));
			// Add the aria-invalid & describedby attrs
			currentQ.setAttribute('aria-invalid', true);
			currentQ.setAttribute('aria-describedby', errorSelector);
		} else {
			// Move the p back into the wrapper
			document.querySelector('#' + errorSelector).parentNode.append(document.querySelector('#' + errorSelector + '-content'));
			// Remove the aria-invalid & describedby attrs
			if (currentQ && currentQ.hasAttribute('aria-invalid')) {
				currentQ.removeAttribute('aria-invalid');
			}
			if (currentQ && currentQ.hasAttribute('aria-describedby')) {
				currentQ.removeAttribute('aria-describedby');
			}
		}
	};

	// Keypress has additional error message checking to alert users, even though the maxlength handles the validation
	const handleKeyPress = (e) => {
		if (text.length === maxChars && e.target.value.length === maxChars) {
			// Move the p into the error message
			document.querySelector('#' + errorSelector).append(document.querySelector('#' + errorSelector + '-content'));
		} else {
			// Move the p back into the wrapper
			document.querySelector('#' + errorSelector).parentNode.append(document.querySelector('#' + errorSelector + '-content'));
		}
	};

	let errorMessage = false;
	if (data[currentQuestion].required || maxChars) {
		if (data[currentQuestion].required || maxChars) {
			errorMessage = t('survey.text.req-max', { maxChars: maxChars });
		} else if (maxChars) {
			errorMessage = t('survey.text.max', { maxChars: maxChars });
		} else {
			errorMessage = t('survey.text.req', { maxChars: maxChars });
		}
	}

	useEffect(() => {
		if (!(Object.values(responses[currentQuestion])[0] === '')) {
			setText(Object.values(responses[currentQuestion])[0]);
		}
	}, [responses[currentQuestion]]);

	return (
		<>
			<main className="survey__panel">
				<p className="question__number">{t('survey.generic.Step')} {[currentQuestion + 1]}/{data.length}</p>
				<div key={[currentQuestion + 1]} className="question__question question__question--textarea">
					<label htmlFor={'q' + [currentQuestion + 1]} className="question__label">
						{data[currentQuestion].title}&nbsp;{(data[currentQuestion].required) ? <span className="question__required">({t('survey.generic.Required')})</span> : ''}
					</label>
					<div className="question__instructions">
						<div className="markdown">
							<Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{data[currentQuestion].instruction}</Markdown>
						</div>
					</div>
					<div className="question__input textarea-wrapper" data-count={text.length} data-max={maxChars} data-chars={t('survey.generic.characters')}>
						<textarea
							value={text}
							id={'q' + [currentQuestion + 1]}
							onChange={(e) => changeHandler(e)}
							onKeyPress={handleKeyPress}
							required={data[currentQuestion].required}
							maxLength={maxChars}
						/>
					</div>
					{(errorMessage) ? <div className="question__error-wrapper"><div id={'q' + [currentQuestion + 1] + 'error'} className="question__error" role="alert" aria-atomic="true"></div><p id={'q' + [currentQuestion + 1] + 'error-content'} className="question__error-content">{errorMessage}</p></div> : ''}
				</div>
			</main>
		</>
	);
}
